import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { UrlFormatter } from 'shared';

/**
 * Native port of the v1 `Image` factory (account-v1/src/core/api/images.js).
 * WS5 #10 Stage A inc 2u: replaces the `$injector.get('Image')` grabs
 * (contest-details now; contest-invitations / ft-touchpoint-messaging later).
 * Both methods return the response BODY (v1 `.then(r => r.data)`).
 */
@Injectable({ providedIn: 'root' })
export class ImageV1ApiService {
  private readonly http = inject(HttpClient);

  /** v1 `Image.getPropertyImages(model)` — model: `{propertyId}`. */
  getPropertyImages(model: any): Promise<any> {
    return firstValueFrom(
      this.http.get(UrlFormatter.format('/api/:propertyId/properties/:propertyId/images', model)),
    );
  }

  /** v1 `Image.uploadPropertyImageFromUrl(propertyId, imageType, url)` — POST, no body (query-string via appendSearch). */
  uploadPropertyImageFromUrl(propertyId: string, imageType: any, url: string): Promise<any> {
    const model = { propertyUUID: propertyId, type: imageType, url };
    return firstValueFrom(
      this.http.post(UrlFormatter.format('/api/:propertyUUID/properties/:propertyUUID/imageFromUrl', model, true), null),
    );
  }
}
